module.exports = __webpack_public_path__ + "assets/img/02-s.e23b13c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/02-s.jpg
// module id = 77VX
// module chunks = 0